var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('h1',[_vm._v(_vm._s(_vm.$t("RegistrationSuccess")))]),_c('p',{staticClass:"mb-1"},[_vm._v(" "+_vm._s(_vm.$t("RegistrationSuccessMsg"))+" ")]),_c('v-icon',{attrs:{"size":"210","color":"green"}},[_vm._v("mdi-check-circle-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }